module.exports = __webpack_public_path__ + "static/media/info_05.9be7d533.jpg";